var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaspCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130.72 36.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7c35f;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{stroke-width:0px;}.cls-2{fill:#80bbce;}.cls-3{fill:#5d6972;}.cls-4{fill:#f7ae44;}.cls-5{fill:#a7cfe0;}.cls-6{fill:#fff;}.cls-7{fill:#7b828a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 79.95,
    y: 30.15,
    width: 9.26,
    height: 3.63,
    transform: "translate(169.16 63.93) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 96.6,
    y: 30.15,
    width: 9.26,
    height: 3.63,
    transform: "translate(202.47 63.93) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 113.26,
    y: 30.15,
    width: 9.26,
    height: 3.63,
    transform: "translate(235.78 63.93) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 71.49,
    y: 14.65,
    width: 9.26,
    height: 3.63,
    transform: "translate(152.24 32.93) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 88.15,
    y: 14.65,
    width: 9.26,
    height: 3.63,
    transform: "translate(185.55 32.93) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 104.8,
    y: 14.65,
    width: 9.26,
    height: 3.63,
    transform: "translate(218.87 32.93) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 121.46,
    y: 14.65,
    width: 9.26,
    height: 3.63,
    transform: "translate(252.18 32.93) rotate(180)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.19,15.59l3.58.9c1.93.48,3.28,2.21,3.28,4.2v7.44c0,2.39-1.94,4.33-4.33,4.33H4.33c-2.39,0-4.33-1.94-4.33-4.33v-3.49c0-4.23,3.06-7.84,7.23-8.53l3.72-.62c1.28-.21,2.4-.99,3.04-2.12l1.41-2.46C19.25,4.16,26.42,0,34.18,0h3.01c7.76,0,14.92,4.16,18.77,10.9l1.51,2.64c.59,1.02,1.56,1.76,2.71,2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M.12,29.08c.45,1.96,2.19,3.36,4.21,3.36h58.4c2.39,0,4.33-1.94,4.33-4.33v-7.44c0-1.98-1.35-3.71-3.28-4.19l-.09-.02c.08.32.12.65.13.97,0,6.5-5.27,11.76-11.76,11.76H1.08c-.32,0-.65-.04-.96-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M66.87,19.47h-4.15s1.08,4.33,1.08,4.33h3.24s0-3.11,0-3.11c0-.41-.06-.82-.17-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.8,23.79h3.24s0-3.11,0-3.11c0-.22-.02-.45-.06-.67-.01-.08-.03-.16-.05-.23-.02-.1-.05-.21-.08-.31h-3.24c-.1.6-.26,1.19-.45,1.77l.64,2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1.73,19.47c-.96,1.26-1.54,2.75-1.69,4.33h2.12s0,0,.01,0c2.39,0,4.32-1.94,4.31-4.33H1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.91,32.44h12.78c.07-.38.1-.77.1-1.16-.02-3.58-2.94-6.47-6.53-6.45-3.58.02-6.47,2.94-6.45,6.53,0,.36.03.72.1,1.08Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 15.14,
    cy: 30.28,
    r: 6.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 15.14,
    cy: 30.28,
    r: 2.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 51.91,
    cy: 30.28,
    r: 6.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46,32.95c.65,1.45,1.81,2.61,3.26,3.26,3.27,1.47,7.11,0,8.58-3.26,1.47-3.27,0-7.11-3.26-8.58.38.84.58,1.76.58,2.68,0,3.58-2.91,6.48-6.49,6.47-.92,0-1.83-.2-2.67-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.23,32.95c.65,1.45,1.81,2.61,3.26,3.26,3.27,1.47,7.11,0,8.58-3.26s0-7.11-3.26-8.58c.38.84.58,1.76.58,2.68,0,3.58-2.91,6.48-6.49,6.47-.92,0-1.83-.2-2.67-.58Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 51.91,
    cy: 30.28,
    r: 2.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M52.47,12.76l.52,1.3h-15.14V3.24h.56c6.19,0,11.76,3.77,14.06,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.85,10.81v3.24s15.14,0,15.14,0l-.52-1.3c-1.38-3.44-3.97-6.25-7.28-7.91,1.26,1.36,2.26,2.94,2.96,4.66l.52,1.3h-10.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M18.9,12.76c2.3-5.75,7.87-9.51,14.06-9.52h.56v10.81h-15.14s.52-1.3.52-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M25.95,8.53c-.37,0-.71-.19-.91-.5-.32-.5-.17-1.17.33-1.49.38-.24.77-.47,1.17-.67.53-.27,1.18-.06,1.46.47.27.53.06,1.18-.47,1.46-.34.17-.67.36-.99.57-.17.11-.38.17-.58.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.9,12.76l-.52,1.3h15.14s0-10.81,0-10.81h-.56c-.9,0-1.8.09-2.68.25v3c0,2.39-1.94,4.33-4.33,4.33h-6.1c-.36.63-.68,1.28-.95,1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M30.28,17.3c0,.6.48,1.08,1.08,1.08h2.16c.6,0,1.08-.48,1.08-1.08,0-.6-.48-1.08-1.08-1.08h-2.16c-.6,0-1.08.48-1.08,1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M50.83,17.3c0,.6.48,1.08,1.08,1.08h2.16c.6,0,1.08-.48,1.08-1.08,0-.6-.48-1.08-1.08-1.08h-2.16c-.6,0-1.08.48-1.08,1.08Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaspCar);
export default __webpack_public_path__ + "static/media/wasp_car.22d9fe3a22a74320c7cb3cb3806bb342.svg";
export { ForwardRef as ReactComponent };